import {
  REGISTER_SUCCESS,
  GET_USERS,
  UPDATE_USER,
  USER_ACTION_FAIL,
  CLEAR_ERRORS,
} from "../types";

const UserReducer = (state, action) => {
  switch (action.type) {
    case REGISTER_SUCCESS:
      return { ...state, new_account: action.payload };

    case GET_USERS:
      return { ...state, users: action.payload };

    case UPDATE_USER:
      return { ...state, user: action.payload };

    case USER_ACTION_FAIL:
      return { ...state, user_error: action.payload };

    case CLEAR_ERRORS:
      return { ...state, user_error: null };

    default:
      return state;
  }
};

export default UserReducer;